/**
 * Magic!!!
 * Signup class name
 * Would be used by layout service to trigger singup form
 * binds to element on a document load.
 */
export const SIGNIN_CLASS_NAME = 'js-open-popup-login';
